export * from './set-radar-tags';
